
(function() {
  if(!window['SellerPanda'] || !window['SellerPanda']['Swatchify']){
    console.error('Swatchify error! Please contact support@sellerpanda.com')
  } else {
    window['SellerPanda']['Swatchify'].swatchify_SetSwatches({swatches: {"Color":{"Gold":"c#FFD700","Grey":"c#808080","NAVY":"c#000080","Navy":"c#000080","Teal":"c#008080","Black":"c#000000","Ivory":"c#FFFFF0","Olive":"c#808000","WHITE":"c#FFFFFF","White":"c#FFFFFF","Salmon":"c#FA8072","Yellow":"c#FFFF00","CRIMSON":"c#DC143C","Crimson":"c#DC143C","Fuchsia":"c#FF00FF","Lavender":"c#E6E6FA","Persimmon":"c#B35C3C","Hawaiian Ocean":"c#487FCA"}}, specific: {}});
  }
}())
